export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[900px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20honey%20gold%20abstract%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20and%20subtle%20geometric%20line%20patterns%2C%20modern%20editorial%20design%20with%20elegant%20minimalist%20aesthetic%2C%20cream%20and%20sand%20tones%20with%20gentle%20coral%20accents%2C%20sophisticated%20luxury%20brand%20atmosphere%2C%20no%20text%20no%20logos%20just%20refined%20abstract%20composition%20with%20delicate%20light%20rays%20and%20ethereal%20texture&width=1600&height=900&seq=hero-vigorbuy-v2-2026&orientation=landscape"
          alt="VigorBuy Spreadsheet resource center background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 md:px-10 text-center pt-20">
        <div className="flex flex-col items-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
            <div className="w-2 h-2 rounded-full bg-accent-400"></div>
            <span className="text-xs font-medium text-background-50 tracking-wide">
              UPDATED WEEKLY · 14 CATEGORIES
            </span>
          </div>

          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-background-50 leading-tight max-w-4xl tracking-tight">
            VigorBuy Spreadsheet
            <br />
            <span className="text-accent-300">Ultimate Buying Guide</span>
          </h1>

          <p className="mt-8 text-base md:text-lg text-background-200 max-w-2xl leading-relaxed">
            Discover updated VigorBuy Spreadsheet resources, buying guides, product comparisons, and safe purchasing tips — all organized in one place for smarter shopping.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 rounded-md bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              VigorBuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Buy It Now
              <i className="ri-shopping-bag-3-line"></i>
            </a>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6">
            {[
              { icon: 'ri-check-double-line', text: 'Updated Resources' },
              { icon: 'ri-shield-check-line', text: 'Safety Information' },
              { icon: 'ri-book-open-line', text: 'Buying Guides' },
              { icon: 'ri-scales-line', text: 'Product Comparisons' },
            ].map((item) => (
              <div
                key={item.text}
                className="flex items-center gap-3 px-5 py-3 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/15"
              >
                <div className="w-8 h-8 rounded-md bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-accent-300 text-sm`}></i>
                </div>
                <span className="text-xs font-medium text-background-100 whitespace-nowrap">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}